// | Additional utilities for dealing generically with records.
// | "2" is appended to the name to avoid conflict with `purescript-record-extra`.
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const rsequence = () => dictApplicative => dictSequenceRecord => Record$dExtra.sequenceRecord()(dictSequenceRecord);
const rsequence2 = dictFunctor => () => dictApplicative => dictSequenceRecord => {
  const rsequence4 = Record$dExtra.sequenceRecord()(dictSequenceRecord);
  return () => dictApplicative1 => {
    const map = dictApplicative1.Apply0().Functor0().map;
    return dictSequenceRecord1 => {
      const $0 = map(rsequence4);
      const $1 = Record$dExtra.sequenceRecord()(dictSequenceRecord1);
      return x => $0($1(x));
    };
  };
};
const mapFieldRecordNil = {mapFieldRecordImpl: v => v1 => v2 => ({})};
const mapFieldRecordImpl = dict => dict.mapFieldRecordImpl;
const mapFieldRecordCons = dictIsSymbol => () => dictMapFieldRecord => () => () => (
  {
    mapFieldRecordImpl: v => f => r => Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r)))(dictMapFieldRecord.mapFieldRecordImpl(Type$dProxy.Proxy)(f)(r))
  }
);
const mapFieldRecord = () => dictMapFieldRecord => dictMapFieldRecord.mapFieldRecordImpl(Type$dProxy.Proxy);
export {mapFieldRecord, mapFieldRecordCons, mapFieldRecordImpl, mapFieldRecordNil, rsequence, rsequence2};
